import React from 'react';
import VerticalProductCard from './subcomponents/VerticalProductCard/VerticalProductCard';
import HorizontalProductCard from './subcomponents/HorizontalProductCard/HorizontalProductCard';
import { ProductCardContainerProps } from './productCardTypes';

export type ProductCardProps = ProductCardContainerProps;

const ProductCard = ({
  children,
  layout = 'portrait',
  ...otherProps
}: ProductCardProps) => {
  switch (layout) {
    case 'portrait':
      return (
        <VerticalProductCard {...otherProps}>{children}</VerticalProductCard>
      );
    case 'landscape':
      return (
        <HorizontalProductCard {...otherProps}>
          {children}
        </HorizontalProductCard>
      );
  }
};

export default ProductCard;
